import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import layoutConf from "../../config/layoutConf";
import BasicCrudScreenHeaderLayout from "../screenTypes/layout/BasicCrudScreenHeaderLayout";
import BasicCrudActionsLayout from "../screenTypes/layout/BasicCrudActionsLayout";
import ToolbarFlexSpacer from "../layout/ToolbarFlexSpacer";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import CustomRecordButton from "../input/CustomRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import AutoForm from "../form/functional/AutoForm";
import getSchema from "../../lib/api/getSchema";
import notificationState from "../../states/notificationState";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import AutoFormViewLayout from "../form/layout/AutoFormViewLayout";

function ProductionResource ( props ) {

    const id = "ProductionResource";
    const table = "ProductionResource";
    const view = "VwProductionResource";

    const { t } = useTranslation();

    const [height, setHeight] = useState(0);

    const [schema, setSchema] = useState();
    const [grid, setGrid] = useState();
    const [api, setApi] = useState();
    const [selectGrid, setSelectGrid] = useState();
    const [isEmpty, setIsEmpty] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        let mounted = true;

        window.addEventListener('resize', handleResize);
        handleResize();

        async function schemaSetting() {
            let schema = await getSchema("ProductionResource");
            if(mounted) {
                setSchema(schema);
            }
        }

        schemaSetting();
        return (() => {
            mounted = false;
            window.removeEventListener('resize', handleResize);
        });
    }, []);

    useEffect(() => {
        if (grid) {
            grid.selectionChanged.addHandler(debounce((grid, event) => {
                if (grid.selectedItems && grid.selectedItems[0]) {

                    setSelectGrid(grid.selectedItems[0]);
                } else {
                    setSelectGrid(undefined);
                };
            }, 10));

            grid.itemsSourceChanged.addHandler(debounce((grid, event) => {
                if (grid.selectedItems && grid.selectedItems[0]) {
                    setSelectGrid(grid.selectedItems[0]);
                } else {
                    setSelectGrid(undefined);
                };
            }, 10));
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);
    
    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onWarning = (msg) => {
        notifyWarning(msg);
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };


    const onInitialized = (grid) => {

        setGrid(grid);

    }

    const onApiInitialized = (api) => {

        setApi(api);

    }

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1);

    }

    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="vertical">
                <ReflexElement flex={0.25}>
                    <BasicCrudScreenType 
                        id={id}
                        table={table}
                        view={view} 
                        headerTitle={t("tableName.ProductionResource")}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        onLoadData={onLoadData}
                        onInitialized={onInitialized}
                        onApiInitialized={onApiInitialized}
                    />
                </ReflexElement>

                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

                <ReflexElement flex={0.75}>
                    <BasicCrudScreenHeaderLayout className="basicCrudScreenHeaderLayout">
                        <BasicCrudActionsLayout>
                            <ToolbarFlexSpacer xs />
                            <BasicCrudScreenActionItemLayout>
                                <CustomRecordButton
                                        id={id}
                                        grid={grid}
                                        refresh={api}
                                        schema={schema}
                                        onSuccess={onSuccess}
                                        mode="create"
                                        title="create"
                                        buttonFullName="buttonName.create"
                                        isFormData
                                    />
                            </BasicCrudScreenActionItemLayout>
                            <BasicCrudScreenActionItemLayout>
                                <CustomRecordButton 
                                        id={id}
                                        grid={grid}
                                        refresh={api}
                                        schema={schema}
                                        isFormData
                                        disabled = {isEmpty}
                                        mode="edit"
                                        method="put"
                                        title="update"
                                        buttonFullName="buttonName.update"
                                        onSuccess={notifySuccess}
                                        modifyUrlCallback = {(url)=> url + "/" + selectGrid.resourceCode }
                                />
                            </BasicCrudScreenActionItemLayout>
                            <BasicCrudScreenActionItemLayout>
                                <DeleteRecordButton
                                    id={id}
                                    schema={schema}
                                    grid={grid}
                                    refresh={api}
                                    color="secondary"
                                    onSuccess={onSuccess}
                                    onFailure={onFailure}
                                    onPartialFailure={onWarning}
                                    disabled = {isEmpty}
                                />
                            </BasicCrudScreenActionItemLayout>
                        </BasicCrudActionsLayout>
                        <AutoFormViewLayout>
                            <AutoForm
                                schema = {schema}
                                mode = "edit"
                                initialData = {{...selectGrid}}
                                onChange = {()=>{}}
                                checkDisabledCallback = {(_, column)=>{
                                    column.required = false;
                                    return true;
                                }}
                            />
                        </AutoFormViewLayout>
                    </BasicCrudScreenHeaderLayout>
                </ReflexElement>
            </ReflexContainer>
        </div>
    )

}

export default ProductionResource;
